import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const OverallTicketChart = ({ collegeName, categories, series }) => {
  const chartOptions = {
    chart: { type: "column", backgroundColor: "transparent" },
    title: {
      text: "TICKET ANALYSIS " + collegeName,
      align: "left",
      style: { fontSize: "16px", fontWeight: "600", color: "#1f2937" },
    },
    xAxis: { categories, crosshair: true },
    yAxis: { allowDecimals: false, min: 0, title: { text: "Tickets Count" } },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        let totalMonth = 0;
        const rows = this.points
          .filter((p) => p.y > 0)
          .map((p) => {
            totalMonth += p.y;
            const breakdown = p.series.userOptions.breakdown ? p.series.userOptions.breakdown[p.point.index] : null;
            return `
              <tr>
                <td style="color:${p.color}; padding-right:5px;">●</td>
                <td>${p.series.name}</td>
                <td style="text-align:right; padding-left:10px;"><b>${p.y}</b></td>
              </tr>
              ${breakdown
                ? `<tr><td></td><td colspan="2" style="padding-left:15px; font-size:0.85em;">(${breakdown})</td></tr>`
                : ""
              }
            `;
          });

        rows.push(`
          <tr>
            <td></td>
            <td><b>Total</b></td>
            <td style="text-align:right; padding-left:10px;"><b>${totalMonth}</b></td>
          </tr>
        `);

        return `<b>${this.x}</b><table style="border-collapse:collapse; margin-top:5px;">${rows.join(
          ""
        )}</table>`;
      },
    },
    plotOptions: {
      column: { stacking: "normal", borderRadius: 4 },
    },
    series,
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default OverallTicketChart;
